import { createActionGroup } from '@ngrx/store';

export const PatrimoineAncetreActions = createActionGroup({
  source: 'Patrimoine Ancetre',
  events: {}
});
